module.exports = __webpack_public_path__ + "img/1522756161.9a5160b6.jpg";